<div class="hero min-h-screen container mx-auto">
    <div class="hero-content text-center">
        <div class="max-w-lg mx-auto">
            <figure>
                <img loading="lazy" src="/nodata.webp" alt="error" />
            </figure>
            <p class="text-black">404</p>
            <p class="text-black">Halaman Tidak Ditemukan</p>
        </div>
    </div>
</div>
